import { render, staticRenderFns } from "./PredmetView.vue?vue&type=template&id=2b9454ff&scoped=true&"
import script from "./PredmetView.vue?vue&type=script&lang=js&"
export * from "./PredmetView.vue?vue&type=script&lang=js&"
import style0 from "./PredmetView.vue?vue&type=style&index=0&id=2b9454ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9454ff",
  null
  
)

export default component.exports